import { forwardRef, Ref, useEffect, useRef } from "react"
import { Checkbox } from "@chakra-ui/react"
import { useCombinedRefs } from "components/Beat/utils/useCombinedRefs"

interface CheckboxProps {
  indeterminate?: boolean
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const IndeterminateCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ indeterminate, onChange, ...rest }, ref: Ref<HTMLInputElement>) => {
    const defaultRef = useRef(null)
    const combinedRef = useCombinedRefs(ref, defaultRef)
    const { checked } = { ...rest }

    useEffect(() => {
      if (combinedRef?.current) {
        combinedRef.current.indeterminate = indeterminate ?? false
      }
    }, [combinedRef, indeterminate])

    return (
      <Checkbox
        type="checkbox"
        ref={combinedRef}
        {...rest}
        onChange={onChange}
        isChecked={checked}
        colorScheme="brand"
        borderColor="neutral.600"
        boxShadow="0 0 1px 2px brand.800"
      />
    )
  }
)
